import {
  ERROR_ASSIGN_PRIVILEGES,
  ERROR_PRIVILEGE,
  LOADING_ASSIGN_PRIVILEGES,
  LOADING_PRIVILEGE,
  SUCCESS_ASSIGN_PRIVILEGES,
  SUCCESS_PRIVILEGE,
} from '../../const/actionTypes';
import { IDataBundleUser } from '../../interfaces/dataBundleUser';

interface IInitialState {
  loading: boolean;
  loadingAssignPrivileges: boolean;
  dataBundle: [];
  dataBundleUser?: IDataBundleUser;
  error: string;
}

const initialState: IInitialState = {
  loading: false,
  loadingAssignPrivileges: false,
  dataBundle: [],
  dataBundleUser: undefined,
  error: '',
};

export type PrivilegeState = Readonly<typeof initialState>;

const privilegesReducer = (
  state = initialState,
  action: any
): PrivilegeState => {
  switch (action.type) {
    case LOADING_PRIVILEGE: {
      return {
        ...state,
        loading: true,
        error: '',
      };
    }

    case SUCCESS_PRIVILEGE: {
      return {
        ...state,
        loading: false,
        dataBundle: action.payload.privileges, //role.privileges,
        dataBundleUser: action.payload,
      };
    }

    case ERROR_PRIVILEGE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case LOADING_ASSIGN_PRIVILEGES: {
      return {
        ...state,
        loadingAssignPrivileges: true,
      };
    }

    case SUCCESS_ASSIGN_PRIVILEGES:
    case ERROR_ASSIGN_PRIVILEGES: {
      return {
        ...state,
        loadingAssignPrivileges: false,
      };
    }

    default:
      return state;
  }
};

export default privilegesReducer;
